import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const useRoute = () => {
  const location = useLocation();
  const [companyId, setCompanyId] = useState(null);

  useEffect(() => {
    // Extract the companyId from the URL path whenever the location changes
    const match = location.pathname.match(/\/company\/([^/]+)/);
    if (match) {
      setCompanyId(match[1]);
    } else {
      setCompanyId(null); // Reset if no companyId is found in the URL
    }
  }, [location]);

  return { companyId };
};
